import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonImg } from '@ionic/vue';

interface Props {
  url: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicImage',
  props: {
    url: null
  },
  setup(__props: any) {

const props = __props as {
  url: string;
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonImg), {
    class: "px-16",
    src: props.url,
    alt: `Failed to load provided image ${props.url}`
  }, null, 8, ["src", "alt"]))
}
}

})